





















import { Section } from './mixins';

import { Component, Vue, Prop, Mixins, Emit, Watch } from 'vue-property-decorator';

@Component({
  components: {
    FormImageUpload: () => import('@/components/forms/ImageUpload.vue'),
  },
})
export default class SectionMedia extends Mixins(Section) {
  @Prop() readonly value!: SectionMedia;

  productMediaUpdated(media: Array<{ default: number; highlight: number; name: string; path: string }>) {
    // @ts-ignore
    this.localValue.media = media.map((file: { id?: number; default: number; highlight: number; name: string; path: string }, i: number) => {
      return {
        id: file.id,
        order: i + 1,
        path: file.path,
        name: file.name,
      };
    });
  }

  get productMedia() {
    if (!this.localValue.media) {
      return [];
    }
    // @ts-ignore
    return this.localValue.media.map((media: ProductImage) => {
      return {
        id: media.id,
        path: media.path,
        name: media.name,
        default: media.order === 1 ? 1 : 0,
        highlight: media.order === 1 ? 1 : 0,
      };
    });
  }
}
